export default __webpack_public_path__ + "static/media/leftArrow.ad8b3cbc.svg";